window.IMask = require('imask').default

let Module = {
    name: 'phone',
    misc: {
        phoneCodesSimplified: require('../misc/phone-codes-simplified.json')
    },
    selectors: {
        input: '#phoneInput'
    },

    init: function () {
        let phoneInput = $(Module.selectors.input);
        if (phoneInput.length === 0) {
            return;
        }

        let countryType = '';
        if (phoneInput.hasClass('custom-country-mask')) {
            countryType = '-phone-mask';
        }

        $(document).on('countries' + countryType + ':init', function (e) {
            Module.setMask(Module.selectors.input, e.countryData.code);
        })

        $(document).on('countries' + countryType + ':changed', function (e) {
            phoneInput.value = '';
            phoneInput.data('value', '');
            Module.setMask(Module.selectors.input, e.countryData.code);
        });

        // change country in the profile change subscription modal
        if (phoneInput.data('subsc-id')) {
            $(document).on('ProfileCountrySelect_' + phoneInput.data('subsc-id') + ':changed', function (e) {
                phoneInput.val('');
                phoneInput.data('value', '');
                Module.setMask(Module.selectors.input, e.countryData.code);
            })
        }
    },

    setMask: function (selector, countryCode) {
        if (this.maskObj) this.maskObj.destroy();
        let mask = Module.misc.phoneCodesSimplified[countryCode];
        if (mask) {
            let maskData = [];
            if(Array.isArray(mask)) {
                mask.forEach((maskItem) => {
                    maskItem = maskItem.replace(/#/g, '0')
                    maskData.push({
                        mask: maskItem,
                    });
                })
            } else {
                maskData = mask.replace(/#/g, '0')
            }

            let maskOptions = {
                mask: maskData,
                overwrite: true,
                autofix: true,
                placeholderChar: '_',
                lazy: false,  // make placeholder always visible
            };

            let element = document.querySelector(selector);
            element.value = $(element).data().value ?? '';

            let maskObj = IMask(element, maskOptions);
            maskObj.updateValue('')
            this.maskOptions = maskOptions;
            this.maskObj = maskObj;

            this._oldValue = null;
            $(Module.selectors.input).on('keyup', e => {
                let value = e.target.value;
                let keyCode = e.keyCode;
                let mask = this.maskOptions.mask;
                let lastValue = this._oldValue;
                this._oldValue = value;
                if (keyCode === 8) { // Backspace
                    let lastMaskCharNum = mask.indexOf(0);
                    let valueWithoutPrefix = value.substr(lastMaskCharNum)
                    let lastValueWithoutPrefix = lastValue ? lastValue.substr(lastMaskCharNum) : null;
                    if (valueWithoutPrefix.match(/\d/) === null
                        && (lastValueWithoutPrefix === valueWithoutPrefix || lastValueWithoutPrefix === null)
                    ) {
                        this.maskObj.destroy();
                        let options = this.maskOptions;
                        options.mask = '+000000000000';
                        options.lazy = true;
                        this.maskObj = IMask(element, options)
                    }
                }
            })
        } else {
            $(selector).val('');
        }
    },
}

module.exports = Module
